import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "nn__projects-container section__padding" }
const _hoisted_2 = { class: "nn__projects__map-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "nn__projects__list-container"
}
const _hoisted_4 = { class: "nn__projects__list-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { style: {"font-weight":"bolder"} }, "Prosjekter", -1)
const _hoisted_6 = { class: "nn__projects__list-button" }
const _hoisted_7 = { style: {"margin-top":"12px"} }
const _hoisted_8 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_google_map_component = _resolveComponent("google-map-component")!
  const _component_footer_component = _resolveComponent("footer-component")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_google_map_component, {
                dataSet: _ctx.mapData,
                markers: true,
                selectable: true,
                onMarkerSelected: _ctx.handleClickedMarker,
                style: {"height":"83.5vh"},
                id: "map",
                ref: "map"
              }, null, 8, ["dataSet", "onMarkerSelected"]),
              (_ctx.projects.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _hoisted_5,
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("a", {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'create-project' })))
                        }, "Nytt prosjekt +")
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("ul", _hoisted_7, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project) => {
                          return (_openBlock(), _createElementBlock("li", {
                            onClick: ($event: any) => (
                    _ctx.$router.push({
                      name: 'project',
                      params: { id: project.id },
                    })
                  ),
                            key: project.id,
                            class: "nn__projects__list-item"
                          }, _toDisplayString(project.name) + " - " + _toDisplayString(project.description), 9, _hoisted_8))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode(_component_footer_component)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}